import { reactive, onUnmounted, nextTick } from 'vue';

// Observa a linha (nome + horário + tag) de cada card curto da agenda e
// marca, por id de reunião, se tudo cabe sem overflow horizontal — quando
// não cabe, o horário é escondido para priorizar nome e tag de status.
export function useFitsWidth() {
  const fitsMap = reactive({});

  let observer = null;
  const elToId = new Map();

  function ensureObserver() {
    if (observer || !window.ResizeObserver) return;
    observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const id = elToId.get(entry.target);
        if (id === undefined) return;
        const el = entry.target;
        fitsMap[id] = el.scrollWidth <= el.clientWidth + 1;
      });
    });
  }

  async function registerRow(id, el) {
    if (!el) return;
    ensureObserver();
    elToId.set(el, id);
    if (fitsMap[id] === undefined) fitsMap[id] = true;
    await nextTick();
    fitsMap[id] = el.scrollWidth <= el.clientWidth + 1;
    if (observer) observer.observe(el);
  }

  function fitsRow(id) {
    return fitsMap[id] !== false;
  }

  onUnmounted(() => {
    if (observer) observer.disconnect();
  });

  return { registerRow, fitsRow };
}
